import styled from 'styled-components';
import {Container} from 'react-bootstrap';

export const TableContainer = styled(Container).attrs(() => ({
    fluid: true,
}))`
  min-width: 75ch;
`;
